import { Link } from 'react-router-dom';

import { campaign } from './campaign';

export function SmsConsentDisclosure() {
  return (
    <span>
      Optional SMS/MMS political text opt-in: By checking this box and submitting this form, I
      consent to receive recurring manually sent political text messages, including SMS and MMS,
      from {campaign.committee}. Message frequency varies. Message and data rates may apply. Reply
      STOP to opt out and HELP for help. Donations may be solicited. Consent is not a condition of
      donating, volunteering, or receiving campaign information. View our{' '}
      <Link to="/terms-and-conditions" className="font-bold text-[#6f2182] underline">
        Terms and Conditions
      </Link>{' '}
      and{' '}
      <Link to="/privacy-policy" className="font-bold text-[#6f2182] underline">
        Privacy Policy
      </Link>
      .
    </span>
  );
}
